import { render } from "./CoBrandLinens.vue?vue&type=template&id=51f3a138&scoped=true"
import script from "./CoBrandLinens.vue?vue&type=script&lang=js"
export * from "./CoBrandLinens.vue?vue&type=script&lang=js"

import "./CoBrandLinens.vue?vue&type=style&index=0&id=51f3a138&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51f3a138"]])

export default __exports__